import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { devicesApiService } from '../../../services/devicesApiService';

export const DEVICES_QUERY_KEY = ['devices'];

export function useDevicesQuery(labId?: string) {
  return useQuery({
    queryKey: [...DEVICES_QUERY_KEY, labId],
    queryFn: () => devicesApiService.getDevices(labId),
  });
}

export function useUpdateDeviceNicknameMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, nickname }: { id: string; nickname: string | null }) =>
      devicesApiService.updateNickname(id, nickname),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: DEVICES_QUERY_KEY }),
  });
}
